import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';

interface IProps {
  customStyling?: any;
  backClicked: () => void;
}

function BackToDashboard(props: IProps) {
  const { backClicked, customStyling } = props;
  return (
    <Button
      variant='text'
      startIcon={<ArrowBackIcon />}
      onClick={backClicked}
      sx={customStyling}>
      BACK TO DASHBOARD
    </Button>
  );
}

export default BackToDashboard;
